var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBookBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    style: {
      enableBackground: "new 0 0 100 100"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M41.5560837,83.7488327H4.5462599c-0.2547688,0-0.501811-0.1003418-0.6830885-0.2817154   c-0.1814661-0.1813965-0.2817152-0.4283676-0.2817152-0.6830902l0.0037687-60.3426666H0.0039572L0,87.1063538h40.8228722   c1.5359612,0,3.0023842,0.7332611,3.9208336,1.9604874c0.5596619,0.7448273,1.4472046,1.1886215,2.3812943,1.1886215h1.8406639   C48.4911766,86.5892105,45.3497238,83.7488327,41.5560837,83.7488327z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.2602997,80.6769104l-26.4047108-6.406311c-0.4322777-0.1042023-0.7371702-0.4901276-0.7371702-0.9339218   l0.0039568-55.0555573H5.514832v3.2224579L5.5110631,81.8192215h35.9948959   C40.5488815,81.3985825,39.4721451,81.0126648,38.2602997,80.6769104z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.8420944,16.4402905c-6.4255562-1.8408537-23.1976852-5.6576223-27.7901115-6.6957512l-0.0039577,62.8318634   l25.6986332,6.2326431c5.5919037,1.5552521,8.6329193,4.0791931,10.2808113,6.4525909l0.0039597-60.0725136   C48.934948,20.5040302,43.9566002,17.3356304,40.8420944,16.4402905z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.418541,22.4413624L96.414772,82.7840271c0,0.5325775-0.4322739,0.9648056-0.964798,0.9648056H58.4401474   c-3.7936401,0-6.9350929,2.8403778-7.4097672,6.5066299h1.8408508c0.9301338,0,1.8176765-0.4437943,2.3773384-1.1886215   c0.9224052-1.2272263,2.3888321-1.9604874,3.9210205-1.9604874h40.8266411L100,22.4413624H96.418541z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.4748192,81.8192215h36.0103493l0.0037689-63.5381012h-5.6073532l-0.0037689,55.0555573   c0,0.4437943-0.3048935,0.8297195-0.737175,0.9339218l-26.4356155,6.4140167   C60.497139,81.0203629,59.4281273,81.40242,58.4748192,81.8192215z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.2186661,78.8167648l25.729538-6.2403641L86.951973,9.7445393   c-4.5924225,1.0381289-21.3645554,4.8548975-27.7901077,6.6957512c-3.1145058,0.89534-8.0928535,4.0637398-8.1893349,8.7681217   l-0.0037689,60.0455246C52.6126938,82.8843689,55.6459846,80.364296,61.2186661,78.8167648z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookBlack);
export default __webpack_public_path__ + "static/media/book-black.72cd06dc52ecdf31c7090977733755aa.svg";
export { ForwardRef as ReactComponent };